"use client";

import { Suspense as RouteSuspense } from 'react';
import { PageLoading as RouteLoading } from '@/app/Components/LoadingBubbles';
import { useSearchParams } from "next/navigation";
import { EventsAuditFixture } from "./auditFixture";
import { EventsDirectoryView } from "./EventsDirectoryView";
import { auditFixtureState } from "@/app/lib/routeStateContract";
import { useEventsDirectoryController } from "./useEventsDirectoryController";
import AssistantButton from "@/app/Components/Assistant/AssistantButton";

function EventsRoute() {
  const state = auditFixtureState(useSearchParams().get("auditFixture"));
  return state ? <EventsAuditFixture state={state} /> : <EventsWorkspace />;
}

export function EventsWorkspace({ embedded = false }: { embedded?: boolean }) {
  const controller = useEventsDirectoryController();
  return <>
    {!embedded ? <AssistantButton context={{
      availablePageActions: ['find_events_for_free_time', 'inspect_event', 'review_event_source'],
    }} /> : null}
    <EventsDirectoryView {...controller} embedded={embedded} />
  </>;
}

// Query-dependent interactive content owns its loading boundary.
export default function RoutePage() { return <RouteSuspense fallback={<RouteLoading title="Loading events" />}><EventsRoute /></RouteSuspense>; }
